/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddPenaltiesDetailsToPenaltyCommand } from '../../models/add-penalties-details-to-penalty-command';
import { AddPenaltiesDetailsToPenaltyCommandResult } from '../../models/add-penalties-details-to-penalty-command-result';

export interface ApiPenaltiesAddPenaltiesDetailsToPenaltyPost$Params {
      body?: AddPenaltiesDetailsToPenaltyCommand
}

export function apiPenaltiesAddPenaltiesDetailsToPenaltyPost(http: HttpClient, rootUrl: string, params?: ApiPenaltiesAddPenaltiesDetailsToPenaltyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddPenaltiesDetailsToPenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPenaltiesAddPenaltiesDetailsToPenaltyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AddPenaltiesDetailsToPenaltyCommandResult>;
    })
  );
}

apiPenaltiesAddPenaltiesDetailsToPenaltyPost.PATH = '/api/Penalties/AddPenaltiesDetailsToPenalty';
